const mapTiles = mapType =>
  Array.from(document.images)
    .filter(img => (mapType === 'satellite' ? /khms/ : /\/vt?/).test(img.src))

export default mapTiles



// WEBPACK FOOTER //
// ./src/helpers/map/mapTiles.js